<template>
  <div class="fullEditor">
    <div class="mx-4 mb-3 d-flex">
      <div class="step_number_circle"><span>3</span></div> Please Copy and Paste the information from the
      <a class="fw-600 text-main mx-1" href="https://travcorp.sharepoint.com/:f:/s/Global/Teams/Groups/EuFmahga-yZNrciX8bA5bQ4BYc4tXAJAg8z807qQx2Z_Qg?e=b4D6bp" target="_blank">template of Optional Experience</a>
      to be added into the Guest Documentation
      <BaseLabelWithPopover width="200px">
          <h6>Template of Optional Experience</h6>
        </BaseLabelWithPopover>
    </div>
    <Editor
      v-model="$v[validationGroupName].guestDocumentation.optionalExperience.$model"
      @blur="$v[validationGroupName].guestDocumentation.optionalExperience.$touch()"
      :validator="$v[validationGroupName].guestDocumentation.optionalExperience"
      :showDebugger="false"
      :disabled="isCompletedQuote" />
  </div>
</template>

<script>
import Editor from '@/components/_shared/Editor.vue'

export default {
  name: 'TabOptionalExperience',
  inject: ['$v'],
  components: { Editor },
  props: {
    validationGroupName: {
      type: String,
      required: true
    },
    isCompletedQuote: {
      type: Boolean,
      required: false
    }
  }
}
</script>
